import { tagName } from "@ember-decorators/component"
import Component from "@ember/component"
import { inject as service } from "@ember/service"
import belongsTo from "cc-frontend/helpers/belongs-to"
import hasManyCollectively from "cc-frontend/helpers/has-many-collectively"

@tagName("")
export default class GroupTemplatesProvider extends Component {
  @service("ember-store") store
  @belongsTo("group", "cardStackTemplatesPlanbook") groupTemplatePlanbook
  @hasManyCollectively("groupTemplatePlanbook", "card-stack", "cardStackTemplates")
  planbookTemplates
}
